<template>
  <!-- 消费明细 -->
  <div class="detail_list">
    <div class="search_condition">
      <el-form :inline="true" :model="formInline" class="demo-form-inline">
        <el-form-item label="消费类型：">
          <el-select
            v-model="formInline.spend_type"
            :popper-append-to-body="false"
            class="consumer-select"
            placeholder="请选择"
            size="medium"
            clearable
            style="width: 156px"
          >
            <el-option v-for="item in spend_type_list" :key="item.value" :label="item.label" :value="item.value"> </el-option>
          </el-select>
        </el-form-item>

        <!--

        <el-form-item label="消费货币：">
          <el-select v-model="formInline.coin_typelist"
                     class="consumer-select"
                     :popper-append-to-body="false"
                     @change="getListInfo"
                     placeholder="请选择"
                     style="width: 156px">
            <el-option v-for="item in coin_typeoptions"
                       :key="item.value"
                       :label="item.label"
                       :value="item.value">
            </el-option>
          </el-select>
        </el-form-item>
        -->
        <el-form-item label="消费时间：">
          <el-date-picker
            v-model="formInline.time"
            class="dataTimer"
            type="daterange"
            size="medium"
            range-separator="-"
            prefix-icon="el-icon-date"
            popper-class="dateTimer-droper"
            value-format="yyyy-MM-dd"
            start-placeholder="开始日期"
            end-placeholder="结束日期"
          >
          </el-date-picker>
        </el-form-item>
        <el-form-item>
          <el-button @click="getListInfo" class="select-btn" plain>查询</el-button>
        </el-form-item>
      </el-form>
    </div>
    <el-table
      border
      :data="tableData"
      :row-style="{ height: '56px', fontSize: '14px' }"
      :cell-style="{ padding: 0 }"
      :header-row-style="tableHeaderRow"
      :header-cell-style="tableHeaderColor"
      height="100%"
      style="width: 100%"
    >
      <el-table-column prop="order_no" label="订单号" align="center" :show-overflow-tooltip="true">
        <template slot-scope="scope">
          <span style="cursor: pointer" class="share-copy" :data-clipboard-text="scope.row.order_no" @click="copy()">{{ scope.row.order_no }}</span>
        </template>
      </el-table-column>
      <el-table-column prop="spend_type_name" label="消费类型" width="99" align="center" :show-overflow-tooltip="true"></el-table-column>
      <el-table-column prop="sender_name" label="主播ID" width="159" align="center" :show-overflow-tooltip="true">
        <template slot-scope="scope">
          <span>{{ scope.row.f_uid }}</span
          ><br />
          <span v-if="scope.row.sender_name">({{ scope.row.sender_name }})</span>
        </template>
      </el-table-column>
      <el-table-column prop="create_time" label="消费时间" width="179" align="center" :show-overflow-tooltip="true">
        <template slot-scope="scope">
          <div class="create_time_top">{{ moment(scope.row.create_time).format("YYYY-MM-DD ") }}</div>
          <div class="create_time_top">{{ moment(scope.row.create_time).format("HH:mm:ss") }}</div>
        </template>
      </el-table-column>
      <el-table-column prop="res_name" label="消费内容" align="center" :show-overflow-tooltip="true"></el-table-column>
      <!--
      <el-table-column prop="coin_type"
                       label="消费货币"
                       width="99"
                       align="center"
                       :show-overflow-tooltip="true"></el-table-column>
      -->

      <el-table-column prop="coin_count" label="消费鹰钻" width="99" align="center" :show-overflow-tooltip="true">
        <template slot-scope="scope">
          <span style="color: #02a8a2" v-if="scope.row.coin_type == 1">{{ scope.row.coin_count / 100 }}</span>
          <span v-else style="color: #333">-</span>
        </template>
      </el-table-column>
      <el-table-column prop="coin_count" label="消费克拉" width="99" align="center" :show-overflow-tooltip="true">
        <template slot-scope="scope">
          <span style="color: #02a8a2" v-if="scope.row.coin_type == 2">{{ scope.row.coin_count / 100 }}</span>
          <span v-else style="color: #333">-</span>
        </template>
      </el-table-column>

      <!-- <el-table-column  prop="sender_name" label="消费赠送" width="144" align="center"></el-table-column> -->
      <div slot="empty" class="search_list">
        <div class="list_body">
          <div class="empty_content">
            <!-- <img src="https://test-1301875615.cos.ap-beijing.myqcloud.com/images/20211013094041773982020-12-15%2021.33.14.jpg"
                 alt="" />
            <div class="empty_text">暂无任何记录哦～</div>
            -->
            <Empty text="暂时没有消费数据" :imgWidth="250" :img="require('@/assets/img/empty/consume.png')"></Empty>
          </div>
        </div>
      </div>
    </el-table>

    <div class="pagination_bottom">
      <el-pagination
        background
        layout="prev, pager, next"
        :page-size="info.size"
        :total="totalCount"
        @size-change="handleSizeChange"
        @current-change="handleCurrentChange"
        :current-page="info.page"
      >
      </el-pagination>
    </div>
  </div>
</template>

<script>
import { post } from "../../util/http";
import { mapState } from "vuex";
import moment from "moment";
import Empty from "@/components/empty/empty";
import Cipboard from "clipboard";
export default {
  components: {
    Empty,
  },
  data() {
    return {
      moment: moment,
      coin_typeoptions: [
        { label: "鹰钻", value: "1" },
        { label: "金坷垃", value: "2" },
        { label: "全部", value: "0" },
      ],
      spend_type_list: [
        { label: "游戏鹰选", value: 2 },
        { label: "礼物", value: 1 },
        { label: "全部", value: 0 },
      ],
      formInline: {
        spend_type: "",
        coin_typelist: "",
        time: [],
      },
      tableData: [],
      info: {
        page: 1,
        size: 8,
      },
      totalCount: 0,
    };
  },
  props: {},
  computed: {
    ...mapState(["userInfo"]),
  },
  created() {
    console.log(this.userInfo);
  },
  mounted() {
    // this.$nextTick(() => {
    //   let keyNode = document.querySelector(".el-date-editor");
    //   console.log(keyNode, "keyNode=====");
    //   if (!keyNode) return;

    //  });
    this.getListInfo();
  },
  filters: {
    formatData: (value) => {
      let date = new Date(value);
      let y = date.getFullYear();
      let MM = date.getMonth() + 1;
      MM = MM < 10 ? "0" + MM : MM;
      let d = date.getDate();
      d = d < 10 ? "0" + d : d;
      let h = date.getHours();
      let m = date.getMinutes();
      let s = date.getSeconds();
      h = h < 10 ? "0" + h : h;
      m = m < 10 ? "0" + m : m;
      s = s < 10 ? "0" + s : s;
      return y + "-" + MM + "-" + d + "" + h + ":" + m + ":" + s;
    },
  },
  methods: {
    copy() {
      var copyBtn = new Cipboard(".share-copy");
      copyBtn.on("success", (e) => {
        this.$message.success("复制成功");
        copyBtn.destroy();
      });
    },
    handleSizeChange(val) {
      this.$set(this.info, "size", val);
      // console.log(`每页 ${val} 条`);
      this.selectList();
    },
    handleCurrentChange(val) {
      this.$set(this.info, "page", val);
      //console.log(`当前页: ${val}`);
      this.getListInfo();
    },
    getListInfo() {
      let data = {
        spend_type: this.formInline.spend_type || 0,
        page: this.info.page,
        size: this.info.size,
      };
      if (this.formInline.time && this.formInline.time.length) {
        data.etimestamp = new Date(this.formInline.time[1]).getTime() / 1000 || "";
        data.stimestamp = new Date(this.formInline.time[0]).getTime() / 1000 || "";
      }
      // console.log(data)
      post({
        url: "/api/order/getSpendList",
        data,
      }).then(({ data: { data } }) => {
        const list = data.list;
        this.tableData = list;
        this.totalCount = data.count;
        // this.$emit('backCount', data.count)
      });
    },
    // 设置表头颜色
    tableHeaderColor({ row, column, rowIndex, columnIndex }) {
      // return 'background-color: #c7e7e2;color:#526e6e;font-size: 14px;font-weight:600; height: 36px;padding: 0px'
      return `
				background-color:#02A8A2;
				color:#ffffff;
				font-size: 14px;
				font-weight:500; 
				height: 36px;
				padding: 0px";
				border : 0px;
			 `;
    },
    tableHeaderRow() {
      //return 'height: 36px'
      return `
				height:56px;
				letter-spacing:1px;
				border-radius : 20px;
			`;
    },
    // handleSizeChange(val) {
    // 	console.log(`每页 ${val} 条`);
    // },
    // handleCurrentChange(val) {
    // 	console.log(`当前页: ${val}`);
    // }
  },
};
</script>

<style lang="stylus" scoped>
.create_time_top {
  line-height: 1;
}
/deep/ .el-form--inline .el-form-item {
  margin-left: 0 !important;
  margin-right: 0px !important;
}

/deep/ .el-date-editor {
  position: relative;

  .el-input__icon {
    // display: none;
  }
}
/deep/.el-form-item__label{
      color: #333;
}

.demo-form-inline {
  // width: 918px;
  // display: flex !important;
  // padding-left: 45px;
  // padding-right: 50px;
  ppadding: 0px 5px;
  justify-content: space-between !important;

  .consumer-select {
    // margin-right: 59px;
  }

  .dataTimer {
    width: 264px;
  }
}

.search_list {
  width: 100%;

  /deep/ .empty_content {
    // height: 250px;
  }

  /deep/ .el-table__empty-text {
    width: 100%;
  }

  .list_body {
    height: 444px;
    display: flex;
    justify-content: center;
    align-items: center;
    flex-direction: column;

    .empty_content {
      img {
        width: 136px;
        height: 156px;
        margin-bottom: 39px;
      }

      .empty_text {
        font-size: 14px;
        color: #999;
        text-align: center;
      }
    }
  }
}
</style>
